import React from 'react';
import { VocabularyWord, Language } from '../../types/Vocabulary';
import './VocabularyMatrix.css';

interface VocabularyGridProps {
  words: VocabularyWord[];
  onCellClick: (word: VocabularyWord) => void;
}

const VocabularyGrid: React.FC<VocabularyGridProps> = ({ words, onCellClick }) => {
  const calculateCoverage = (word: VocabularyWord): number => {
    // Count translations excluding the word's own language
    // Maximum is 3 (since there are 4 languages total, and one is the word's language)
    return word.translations?.filter(t => t.language !== word.language).length || 0;
  };

  const getCoverageColor = (coverage: number): string => {
    switch (coverage) {
      case 0:
        return '#fafafa';
      case 1:
        return '#e8f2f8';
      case 2:
        return '#d1e5f1';
      case 3:
        return '#b3d4e6';
      default:
        return '#fafafa';
    }
  };

  const handleCellClick = (word: VocabularyWord) => {
    onCellClick(word);
  };

  return (
    <div className="vocabulary-grid-container">
      <div className="vocabulary-grid-scrollable">
        {words.map(word => {
          const coverage = calculateCoverage(word);
          const backgroundColor = getCoverageColor(coverage);
          
          return (
            <div
              key={word.id}
              className="vocabulary-grid-cell"
              style={{ backgroundColor }}
              onClick={() => handleCellClick(word)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleCellClick(word);
                }
              }}
            >
              <div className="vocabulary-grid-cell-content">
                <span className="vocabulary-grid-cell-word">{word.word}</span>
                {coverage > 0 && (
                  <span className="vocabulary-grid-cell-coverage">{coverage}/3</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VocabularyGrid;

